// Auto-generated page descriptions - English
export default {
  arena: {
    mission: `<b>[Page Description]</b>
A page for managing Arena missions.
You can view, add, edit, and delete missions, and compose the body using SmartEditor.
Images are uploaded via the TUS protocol.

<b>[Column Description]</b>
code :              Mission code (unique number)
description :       Mission description
postingtime :       Posting date and time
deadline :          Deadline date and time
livetime :          Live date and time
missiontype :       Mission type
buttoncount :       Number of buttons
prize :             Prize (ARENA)
prize_metaq :       Prize (METAQ)
entry_fee :         Entry fee
limited :           Maximum number of participants
required metaq :    Required METAQ to participate
engagement :        Current participation count (participant list can be copied)
status :            Status (0: Inactive, 1: Active)
edit / delete :     Edit / Delete buttons`,
    tokens: `<b>[How to Use]</b>
1. Register an Arena token distribution list by uploading a CSV file or manually entering Address and Amount.
2. Clicking the Upload button opens a dialog to enter Round and Description.
3. Use the Send button to submit a batch distribution request for the registered list.

<b>[Column Description]</b>
Sequential : Sequence number (auto-generated)
Address :    Recipient wallet address (valid EVM address required)
Amount :     Amount of Arena tokens to distribute

<b>[File Upload Format]</b>
CSV file (delimiter: comma), enter data only without headers
# Receiving Address, Amount
0x0645Af43088813C44399B79FF45896D68eB23b8F, 100
0x32a4598fCB7272C022557B28dFb8021b6df53F55, 100

<b>[Registration Dialog]</b>
Round :       Distribution round number (automatically set to last round + 1)
Description : Distribution description (e.g., "Mission reward", "Event reward")

<b>[Notes]</b>
* If an address is not a valid EVM address, a warning is shown and it is ignored.
* If Amount is not a number, a warning is shown and it is ignored.`,
    tokensHistory: `<b>[Page Description]</b>
A page for viewing Arena token (ARENA) distribution/deduction history.
Provides CSV download functionality and displays the total distributed amount (Total) at the top.

<b>[Column Description]</b>
Round :         Round number (times)
Sequential :    Sequence number (idx)
Address :       Wallet address
ARENA :         Distribution/deduction amount
Description :   Reason
Created Date :  Created date and time`,
  },
  erc1155: {
    erc1155Holder: `<b>[Page Description]</b>
A page for viewing the list of ERC-1155 token holders.
You can check the held quantity per address, with sorting, searching, and CSV download features.

<b>[Column Description]</b>
Address :  Token holder wallet address (Explorer link provided)
Quantity : Amount of ERC-1155 tokens held by the address

<b>[Features]</b>
* Filter addresses by search keyword
* Column sorting (Address, Quantity)
* CSV download (full holder list, with progress indicator)
* Total display: sum of all token holdings`,
    erc1155Inventory: `<b>[Page Description]</b>
ERC-1155 NFT inventory (ownership status) page.
View metadata (image, name, description, attributes) for each token.

<b>[Column Description]</b>
Token ID :    NFT token ID (ERC-1155 allows multiple issuances with the same ID)
Image :       NFT image (click to navigate to Explorer or IPFS link)
Name :        NFT name
Description : NFT description
Attributes :  NFT attributes (trait_type:value format)

<b>[Features]</b>
* Filter inventory by search keyword
* CSV download (full inventory, with progress indicator)
* Click an image to open the Etherscan NFT page or IPFS image`,
    erc1155Metadata: `<b>[Page Description]</b>
A page for managing ERC-1155 NFT metadata.
Upload a pipe (|) delimited text file to register metadata, and view/download existing lists.

<b>[Column Description]</b>
Token ID :    NFT token ID
Image :       NFT image (click to open the original image)
Name :        NFT name
Description : NFT description
Attributes :  NFT attributes (trait_type:value format)
File Hash :   File server hash

<b>[File Upload Format]</b>
Text file (delimiter: pipe |), enter data only without headers
# tokenId | name | description | image | attributes

1 | CoinGrid Collection 1 | SKYPlay NFT | https://nft.skyplay.io/files/4f3fd03c2d111b8f95d3615c87991257 | {"English Name": "Ali", "Korean Name": "엘리"}
2 | CoinGrid Collection 2 | SKYPlay NFT | https://nft.skyplay.io/files/1bf3fc344ebe5a22cd509fc80afc8c5d | {"English Name": "Bubble", "Korean Name": "버블"}

<b>[Notes]</b>
* Each field is separated by a pipe (|), and all 5 fields are required.
* Attributes must be a valid JSON string.
* Clicking the Upload button registers the metadata to the server after confirmation.`,
    erc1155Transaction: `<b>[Page Description]</b>
A page for viewing transaction history of ERC-1155 contracts.
Provides date range filters, type-based search (All/Hash/Type), and CSV download features.

<b>[Column Description]</b>
Block Number :     Block number containing the transaction
Transaction Hash : Transaction hash (Explorer link provided)
Time :             Transaction time (converted to local time)
Type :             Transaction type (transfer, mint, etc.)

<b>[Features]</b>
* Search type selection (All, Hash, Type)
* Date range filter (fromDate ~ toDate) to set the query range
* CSV download (full transaction data, with progress indicator)`,
    erc1155Transfer: `<b>[Page Description]</b>
A page for viewing ERC-1155 token transfer history.
Provides date range filters, search, and CSV download features. System wallet addresses are highlighted in green.

<b>[Column Description]</b>
Block Number :     Block number containing the transaction
Transaction Hash : Transaction hash (Explorer link provided)
Time :             Transfer time (converted to local time)
From :             Sender address (email/name displayed preferentially, system wallet in green)
To :               Recipient address (email/name displayed preferentially, system wallet in green)
TokenIds :         List of transferred token IDs
Quantities :       Transfer quantity per token ID

<b>[Features]</b>
* Date range filter (fromDate ~ toDate) to set the query range
* Filter by search keyword
* CSV download (full data with paged download, with progress indicator)
* Column settings (ColumnSettings) to customize displayed columns
* From/To address edit (Edit) feature available`,
    nft1155Add: `<b>[How to Use]</b>
1. Register a minting list by uploading a CSV file or manually entering Owner, Token ID, and Amount.
2. Clicking the Upload button sends the registered list as an ERC-1155 minting request.

<b>[Column Description]</b>
Sequential : Sequence number (auto-generated)
Owner :      NFT owner wallet address (minting recipient address)
Token ID :   Token ID to mint (ERC-1155 allows multiple issuances with the same ID)
Amount :     Minting quantity for the Token ID

<b>[File Upload Format]</b>
CSV file (delimiter: comma), enter data only without headers
# owner, tokenId, amount
0x18817A4d5C25d3B43eE6EB1cD29304A7133fD877, 1, 100
0x18817A4d5C25d3B43eE6EB1cD29304A7133fD877, 2, 100

<b>[ERC-721 vs ERC-1155]</b>
ERC-721 :  Each token is unique (1:1), individual metadata (name, image, attributes)
ERC-1155 : Multiple issuances possible with the same Token ID (1:N), suitable for game items, etc.

<b>[Notes]</b>
* 5 fields (owner, tokenId, amount, -, attributes) are required and attributes must be valid JSON.
* Owner must be a valid EVM address.`,
    nft1155Mint: `<b>[Page Description]</b>
A page for managing the ERC-1155 NFT minting queue.
Provides minting start/stop, individual enable/delete features, and auto-refreshes every 3 seconds.

<b>[Column Description]</b>
Owner :            Minting recipient address (Explorer link provided)
Token ID :         Token ID to mint (ERC-1155 allows multiple issuances with the same ID)
Amount :           Minting quantity for the Token ID
Transaction Hash : Minting transaction hash (displayed when minting is complete)
Enabled :          Minting enable checkbox (disabled when minting is complete)
Delete :           Item delete button

<b>[Features]</b>
* Start/Stop : Start/stop the minting process
* Select All : Toggle enable for all items
* CSV download (minting queue list, with progress indicator)
* Auto-polling every 3 seconds to refresh minting status`,
  },
  erc20: {
    airdrop: `<b>[Page Description]</b>
A page for managing the airdrop pending list.
You can view, delete, batch delete, and download CSV for airdrop items in pending status (status=0).
Use the Start/Stop button to control the airdrop process.

<b>[Column Description]</b>
Round            : Airdrop round number
Sequential       : Sequence number
Address          : Recipient wallet address
Amount           : Token quantity to transfer
System Wallet    : System wallet
Description      : Description
Transaction Hash : Transaction hash (displayed when transfer is complete)
Modified Date    : Modified date
Created Date     : Created date

<b>[Reference]</b>
- Auto-refresh every 3 seconds (checks process status and refreshes list)
- Items that already have a transactionHash cannot be deleted or selected`,
    airdropAdd: `<b>[How to Use]</b>
1. Register a transfer list by uploading a CSV file or entering manually.
2. Clicking the Upload button displays a dialog to set Round, Description, and System Wallet.
3. Use the Send button to submit the registered list for batch transfer.

<b>[Column Description]</b>
Sequential : Sequence number (auto-generated)
Address :    Recipient wallet address (valid EVM address required)
Amount :     Token quantity to transfer

<b>[File Upload Format]</b>
CSV file (delimiter: comma), enter data only without headers
# Receiving Address, Amount
0x0645Af43088813C44399B79FF45896D68eB23b8F, 100
0x32a4598fCB7272C022557B28dFb8021b6df53F55, 100

<b>[Registration Dialog]</b>
Round :         Transfer round number (automatically set to last round + 1)
Description :   Transfer description (e.g., "Event Reward", "Airdrop Round 1")
System Wallet : Select the system wallet to use for sending (only active wallets are shown)

<b>[Notes]</b>
* Addresses that are not valid EVM addresses will be ignored with a warning.
* If Amount is not a number, it will be ignored with a warning.
* A System Wallet must be selected before transfers can proceed.`,
    airdropHistory: `<b>[Page Description]</b>
A page for viewing completed airdrop history.
You can search airdrop items in completed status (status=1) by round or date range.
Supports downloading detailed CSV and summary report CSV.

<b>[Column Description]</b>
Round            : Airdrop round number
Sequential       : Sequence number
Address          : Recipient wallet address (displays name if registered)
Amount           : Transferred token quantity (green if over 3,000 / yellow if over 5,000 / red if over 10,000)
Description      : Description (inline editable)
Memo             : Memo (inline editable)
Transaction Hash : Transaction hash
Modified Date    : Modified date

<b>[Reference]</b>
- Use the Round filter to view a specific round only
- Download Detail: Per-item detailed CSV
- Download Report: Per-round summary report CSV`,
    dashboard: `<b>[Page Description]</b>
A real-time monitoring dashboard page for ERC20 tokens.
Data is refreshed in real-time via SSE (Server-Sent Events) and Polling.

<b>[Real-time Cards]</b>
LBank Price       : Current token price on LBank exchange
24h Change         : 24-hour price change rate (%)
Bot Status         : MM bot active/inactive status
Trading Volume     : Trading volume

<b>[Transfer Stats Cards]</b>
Withdraw 24h       : Withdrawal amount in the last 24 hours
Transfers 1h       : Number of transfers in the last 1 hour
Transfers 1h Amt   : Transfer amount in the last 1 hour
Transfers 24h      : Number of transfers in the last 24 hours
Transfers 24h Amt  : Transfer amount in the last 24 hours

<b>[Charts]</b>
TYPE Distribution     : Token distribution donut chart by wallet type (Default, Company, Exchange, etc.)
EXCHANGE Distribution : Token distribution donut chart by exchange
Transfer Bar Chart    : Transfer amount/count bar chart by period (24H / 7D / 30D / Monthly / Custom)
LBank Trading Volume  : LBank trading volume line chart (7D / 30D / 90D)
Daily PnL             : Daily profit and loss chart (7D / 30D / 90D)
Holder Distribution   : Holder distribution chart by balance range

<b>[Reference]</b>
- Auto Refresh polling every 30 seconds
- SSE connection status display (Live / Offline)`,
    erc20DepositHistory: `<b>[Page Description]</b>
A page for viewing ERC20 token deposit history.
You can search deposit transactions detected on the blockchain by date range and download CSV.

<b>[Column Description]</b>
Block Number : Block number
Time         : Transaction timestamp
From         : Sender wallet address (displayed in green if it is a system wallet)
To           : Recipient wallet address
Value        : Deposited token quantity (green if over 3,000 / yellow if over 5,000 / red if over 10,000)

<b>[Reference]</b>
- Use the date filter (From/To Date) to set the search range
- System wallet addresses are highlighted in green`,
    erc20Holder: `<b>[Column Description]</b>
Address : Token holder wallet address
Type :    Holder classification (editable, see Type Codes below)
Owner :   Holder alias/name (editable)
Amount :  Token balance

<b>[Search Options]</b>
All :     Search all
Name :    Search by alias (Owner)
Type :    Search by Type code (enter a number)
More :    Filter holders with balance greater than or equal to the input value
Less :    Filter holders with balance less than or equal to the input value

<b>[File Upload Format]</b>
Batch update holder information via CSV file (delimiter: comma)
# Holder Address, Alias, Type
0x0645Af43088813C44399B79FF45896D68eB23b8F, User_1, 11
0x32a4598fCB7272C022557B28dFb8021b6df53F55, User_2, 11

<b>[Type Codes]</b>
 0  Default       — Unclassified
 1  Company       — Company holdings
 2  Exchange      — Exchange
 3  Marketing     — Marketing allocation
 4  Sale          — Sale allocation
 5  Staking       — Staking
 6  Team          — Team allocation
 7  CM liquidity  — Community liquidity
 8  Advisor       — Advisor
 9  Unlock        — Unlocked allocation
10  Portal        — Portal system
11  System        — System wallet`,
    erc20LockupSchedules: `<b>[Page Description]</b>
A page for viewing ERC20 token lockup schedules.
You can check the lockup information configured in the smart contract.

<b>[Column Description]</b>
account           : Wallet address subject to lockup
amount            : Locked token quantity
startTime         : Lockup start time
releasePercentage : Release percentage (%)
releasedValue     : Released token quantity

<b>[Reference]</b>
- CSV download supported`,
    erc20Transaction: `<b>[Page Description]</b>
A page for viewing ERC20 contract transaction history.
You can search contract transactions on the blockchain by type or hash.

<b>[Column Description]</b>
Block Number     : Block number
Transaction Hash : Transaction hash
Time             : Transaction timestamp
Type             : Transaction type (transfer, approve, etc.)

<b>[Search Options]</b>
All  : Search all
Hash : Search by transaction hash
Type : Search by transaction type

<b>[Reference]</b>
- Use the date filter (From/To Date) to set the search range
- CSV download supported`,
    erc20TransactionStatus: `<b>[Page Description]</b>
A page for monitoring transaction status.
You can check the processing status of transactions sent to the blockchain, and retry or delete failed ones.

<b>[Column Description]</b>
Address          : Recipient wallet address
Transaction Hash : Transaction hash
Status           : Transaction status (PENDING: waiting / FAILED: failed / other)
Modified Date    : Modified date
Created Date     : Created date
Retry            : Button to retry failed transactions
Delete           : Button to delete transaction records

<b>[Reference]</b>
- FAILED status is displayed as a red chip, PENDING status as an orange chip
- CSV download supported`,
    erc20Transfer: `<b>[Page Description]</b>
A page for viewing ERC20 token transfer history.
You can search token transfer transactions on the blockchain using various search criteria.

<b>[Column Description]</b>
Block Number     : Block number
Transaction Hash : Transaction hash
Time             : Transaction timestamp
From             : Sender wallet address (system wallet in green, displays name/email if registered)
To               : Recipient wallet address (system wallet in green, displays name/email if registered)
Value            : Transferred token quantity

<b>[Search Options]</b>
All  : Search all
Hash : Search by transaction hash
Name : Search by name
Type : Search by address type
More : Search for amounts greater than or equal to the input value
Less : Search for amounts less than or equal to the input value
From : Search by sender address
To   : Search by recipient address

<b>[Reference]</b>
- Use the date filter (From/To Date) to set the search range
- Address name/type editing modal provided
- CSV download supported`,
    erc20Withdraw: `<b>[Page Description]</b>
A page for managing the withdrawal request pending list.
You can approve/reject withdrawal requests from users and Start/Stop the withdrawal process.
Supports Batch Approve and Batch Reject functionality.

<b>[Column Description]</b>
Issuer           : Issuer (request source)
Address          : Recipient wallet address (displays name if registered, duplicate addresses shown in yellow)
Amount           : Withdrawal request amount (green if over 3,000 / yellow if over 5,000 / red if over 10,000)
Transaction Hash : Transaction hash (displayed when processing is complete)
Request Date     : Withdrawal request date and time
System Wallet    : System wallet selection
Enabled          : Withdrawal activation checkbox

<b>[Reference]</b>
- Request Date basis: 05:00 UTC (14:00 KST)
- Auto-refresh every 3 seconds (checks process status and refreshes list)
- Blacklist registration button available to block addresses
- Select All button to toggle all activations on/off`,
    erc20WithdrawBlacklist: `<b>[Page Description]</b>
A page for managing the withdrawal blacklist.
You can view addresses registered on the blacklist, edit reasons, and remove addresses from the blacklist.

<b>[Column Description]</b>
Issuer                       : Issuer
Address                      : Blacklisted wallet address (displayed in red)
Withdrawal Suspension Reason : Reason for withdrawal suspension (inline editable)
Registered Date              : Blacklist registration date

<b>[Reference]</b>
- Restore (remove from blacklist) button appears on address hover
- CSV download supported`,
    erc20WithdrawHistory: `<b>[Page Description]</b>
A page for viewing completed withdrawal history.
You can search completed withdrawals (status=1) by date range and download CSV.

<b>[Column Description]</b>
Issuer           : Issuer (request source)
Address          : Recipient wallet address (blacklisted in red, duplicate addresses in yellow)
Amount           : Withdrawal amount (green if over 3,000 / yellow if over 5,000 / red if over 10,000)
Transaction Hash : Transaction hash
Request Date     : Withdrawal request date and time
Withdrawal Date  : Withdrawal processing date and time

<b>[Reference]</b>
- Use the date filter (From/To Date) to set the search range
- Blacklist registration button available to block addresses
- Expanding an address shows a list of users with the same address`,
    erc20WithdrawHold: `<b>[Page Description]</b>
A page for viewing the withdrawal hold list.
Manages withdrawals in hold status (status=4).

<b>[Column Description]</b>
Issuer        : Issuer (request source)
Address       : Recipient wallet address (blacklisted in red, duplicate addresses in yellow)
Amount        : Held withdrawal amount (green if over 3,000 / yellow if over 5,000 / red if over 10,000)
Request Date  : Withdrawal request date and time

<b>[Reference]</b>
- Blacklist registration button available to block addresses
- CSV download supported`,
    erc20WithdrawRefusal: `<b>[Page Description]</b>
A page for viewing withdrawal refusal history.
You can view the list of withdrawal requests rejected by administrators (status=3).

<b>[Column Description]</b>
Issuer           : Issuer (request source)
Address          : Recipient wallet address (blacklisted in red, duplicate addresses in yellow)
Amount           : Withdrawal request amount (green if over 3,000 / yellow if over 5,000 / red if over 10,000)
Rejection Reason : Reason for rejection
Request Date     : Withdrawal request date and time

<b>[Reference]</b>
- CSV download supported
- Expanding an address shows a list of users with the same address`,
    holderAnalysis: `<b>[Page Description]</b>
An ERC20 token holder analysis page.
You can analyze the token holder status using various charts and tables.

<b>[Summary Cards]</b>
Total Holders       : Total number of holders
Total Supply        : Total token supply
Top 10 Concentration : Holding ratio of the top 10 addresses (%)
Average Balance     : Average balance per holder

<b>[Charts]</b>
Top Holder Concentration : Top holder (Top 10/50/100) concentration donut chart
Balance Distribution     : Holder distribution by balance range (0-100, 100-1K, 1K-10K, etc.)
Holder Type Breakdown    : Holder distribution donut chart by type
Type Summary             : Summary table of balance and ratio by type

<b>[Top Holders Table]</b>
#          : Rank
Address    : Wallet address
Name       : Registered name
Balance    : Token balance
Share      : Holding ratio of total supply (%)
Cumulative : Cumulative holding ratio (%)

<b>[Reference]</b>
- CSV / Excel / PDF export supported`,
    rules: `<b>[Page Description]</b>
A page for managing withdrawal rules.
You can create, edit, and delete rules to apply during withdrawals.

<b>[Rule Types]</b>
Quantity (Type 0)  : Set a per-withdrawal quantity limit
Frequency (Type 1) : Set a withdrawal frequency limit within a specified period (seconds)
Address (Type 2)   : Set rules based on a specific wallet address

<b>[Reference]</b>
- Add new rules with the Add Rules button
- Manage existing rules with the edit/delete buttons`,
    skyPlayWallet: `<b>[Page Description]</b>
A page for managing user wallets.
You can view wallet addresses and token balances per account, and create new wallets.

<b>[Column Description]</b>
Account ID    : User account ID (displayed in red if blacklisted)
Address       : Wallet address
Nickname      : Nickname
MATIC         : MATIC balance (real-time RPC query)
METAQ         : METAQ token balance
Modified Date : Modified date
Created Date  : Created date

<b>[Reference]</b>
- Create a new wallet based on AccountId with the Create Wallet button
- Blacklist registration available
- CSV download supported`,
    crossNetwork: `<b>[Page Description]</b>
This is the Cross-Network Analysis page.
It provides a unified view of activity across ERC20, ERC721, and ERC1155 token types.
Compare network metrics side-by-side and track activity timelines per token standard.

<b>[Filters]</b>
Token Type Toggle : Filter by All / ERC20 / ERC721 / ERC1155
From / To :         Date range filter
Address Search :    Search all activity for a specific wallet address

<b>[Summary Cards]</b>
Total Transactions : Total transaction count across all networks
Unique Addresses :   Count of distinct wallet addresses
Active Networks :    Number of networks with activity
ERC20 / ERC721 / ERC1155 : Transaction count breakdown by token type

<b>[Charts]</b>
Network Comparison :  Stacked bar chart showing transfers, mints, and burns per network
Activity Timeline :   Line chart with separate series for ERC20, ERC721, and ERC1155 daily activity

<b>[Tables]</b>
Network Breakdown :   Detailed per-network metrics (type, TX count, unique addresses, transfers, mints, burns)
Combined Activity :   Merged activity feed sorted by timestamp (Time, Type, Action, From, To, Amount/TokenId, Network, TX Hash)

<b>[Address Search]</b>
Enter an Ethereum address to view all its cross-network activity across all token types.`,
    holderTracking: `<b>[Page Description]</b>
A time-series holder tracking page for ERC20 tokens.
Track holder count changes, distribution shifts, and top holder movements over time using periodic snapshots.

<b>[Filters]</b>
From / To :   Date range for snapshot data
Group By :    Aggregate snapshots by Day / Week / Month

<b>[Summary Cards]</b>
Total Holders :      Current total number of token holders
New Holders (24h) :  Number of new holders in the last 24 hours
Left Holders (24h) : Number of holders who left in the last 24 hours
Avg Balance :        Average token balance per holder

<b>[Charts]</b>
Holder Count Over Time :  Line chart showing total holder count changes over selected period
Distribution History :    Stacked area chart showing holder distribution across balance buckets (0-100, 100-1K, 1K-10K, 10K-100K, 100K+)

<b>[Top 20 Holders Table]</b>
Rank :       Holder rank by balance
Address :    Wallet address
Name :       Registered name/alias
Balance :    Current token balance
Share % :    Percentage of total supply
24h Change : Balance change in last 24 hours
7d Change :  Balance change in last 7 days

<b>[Features]</b>
- Take Snapshot : Manually trigger a holder snapshot (captures current state to database)
- CSV / Excel / PDF export supported
- Dark/light theme support for all charts`,
  },
  erc721: {
    erc721Holder: `<b>[Page Description]</b>
A page for viewing the list of ERC-721 token holders.
You can check the balance per address, with sorting, search, and CSV download features.

<b>[Column Description]</b>
Address :  Token holder wallet address (Explorer link provided)
Quantity : Number of ERC-721 tokens held by the address

<b>[Features]</b>
* Filter addresses by search keyword
* Column sorting (Address, Quantity)
* CSV download (full holder list, progress indicator)
* Total display: sum of all token holdings`,
    erc721Inventory: `<b>[Page Description]</b>
ERC-721 NFT inventory (ownership status) page.
View metadata (image, name, description, attributes) and owner information for each token.

<b>[Column Description]</b>
Token ID :    Unique NFT token ID
Image :       NFT image (click to navigate to Explorer or IPFS link)
Owner :       Current owner wallet address (Explorer link provided)
Name :        NFT name
Description : NFT description
Attributes :  NFT attributes (trait_type:value format)

<b>[Features]</b>
* Filter inventory by search keyword
* CSV download (full inventory, progress indicator)
* Click image to open Etherscan NFT page or IPFS image`,
    erc721Transaction: `<b>[Page Description]</b>
A page for viewing transaction history of the ERC-721 contract.
Provides date range filter, type-based search (All/Hash/Type), and CSV download.

<b>[Column Description]</b>
Block Number :     Block number containing the transaction
Transaction Hash : Transaction hash (Explorer link provided)
Time :             Transaction time (converted to local time)
Type :             Transaction type (transfer, mint, etc.)

<b>[Features]</b>
* Search type selection (All, Hash, Type)
* Date range filter (fromDate ~ toDate) to set query range
* CSV download (full transaction data, progress indicator)`,
    erc721Transfer: `<b>[Page Description]</b>
A page for viewing ERC-721 token transfer history.
Provides date range filter, search, and CSV download. System wallet addresses are highlighted in green.

<b>[Column Description]</b>
Block Number :     Block number containing the transaction
Transaction Hash : Transaction hash (Explorer link provided)
Time :             Transfer time (converted to local time)
From :             Sender address (email/name displayed if available, system wallet in green)
To :               Receiver address (email/name displayed if available, system wallet in green)
Token ID :         Transferred NFT token ID

<b>[Features]</b>
* Date range filter (fromDate ~ toDate) to set query range
* Filter by search keyword
* CSV download (full data with paged download, progress indicator)
* Column customization via ColumnSettings`,
    nft721Add: `<b>[How to Use]</b>
1. Upload a pipe(|) delimited text file to register an NFT minting list.
2. Click the Upload button to submit the registered list as a minting request.

<b>[Column Description]</b>
Sequential :  Sequence number (auto-generated)
Owner :       NFT owner wallet address (minting recipient address)
Name :        NFT name (collection name)
Description : NFT description
Image :       NFT image URL (TUS file upload server URL, etc.)
Attributes :  NFT metadata attributes (JSON format required)

<b>[File Upload Format]</b>
Text file (delimiter: pipe |), data only without header
# owner | name | description | image | attributes

0x18817A4d5C25d3B43eE6EB1cD29304A7133fD877 | Collection 1 | METAPLANET NFT | https://appsdev.metaplanet.tech/files/e4606e4f42f73b832ba8b530f8a4e8d1 | {"English Name": "MARRON"}
0x18817A4d5C25d3B43eE6EB1cD29304A7133fD877 | Collection 2 | METAPLANET NFT | https://appsdev.metaplanet.tech/files/a80bb676e130f46184d7b4554eeaf364 | {"English Name": "PENNY"}

<b>[Notes]</b>
* Each field is separated by a pipe(|), and all 5 fields are required.
* Attributes must be a valid JSON string. (Lines with parsing failures will be ignored)
* Image URLs are displayed as preview images in the table.`,
    nft721Mint: `<b>[Page Description]</b>
A page for managing the ERC-721 NFT minting queue.
Provides start/stop minting, individual/batch enable, and delete features with auto-refresh every 3 seconds.

<b>[Column Description]</b>
Image :            NFT image preview
Name :             NFT name
Description :      NFT description
File Hash :        File server hash (file link provided)
Owner :            Minting recipient address (Explorer link provided)
Attributes :       NFT attributes (trait_type:value format)
Transaction Hash : Minting transaction hash (displayed when minting is complete)
Enabled :          Minting enable checkbox (disabled when minting is complete)
Delete :           Item delete button

<b>[Features]</b>
* Start/Stop : Start/stop the minting process
* Select All : Toggle enable for all items
* Batch Enable : Enable selected items in batch
* Batch Delete : Delete selected items in batch
* CSV download (minting queue list, progress indicator)
* Auto-polling every 3 seconds to refresh minting status`,
    nft721MintHistory: `<b>[Page Description]</b>
A page for viewing ERC-721 NFT minting completion history.
View detailed information and transaction hashes for minted NFT items.

<b>[Column Description]</b>
Image :            NFT image preview
Name :             NFT name
Description :      NFT description
Owner :            NFT owner wallet address (Explorer link provided)
Attributes :       NFT attributes (trait_type:value format)
Transaction Hash : Minting transaction hash (Explorer link provided)
Updated Date :     Last modified date
Created Date :     Initial registration date

<b>[Features]</b>
* Filter minting history by search keyword
* CSV download (full minting history, progress indicator)
* Only shows items with status=1 (minting complete)`,
  },
  mpc: {
    createWallet: `<b>[Page Description]</b>
A page for creating MPC (Multi-Party Computation) wallets.
Create by setting the wallet name, owner list, and minimum number of approvers (threshold).

<b>[Input Fields]</b>
Wallet Name :             MPC wallet name
Wallet Creator :          Default approver user (logged-in user)
Approver Users :          Select additional owners (from registered MPC user list)
Minimum Approvers :       Minimum number of people required to approve a transaction (threshold)`,
    issueTransaction: `<b>[Page Description]</b>
A page for requesting token transfers from an MPC wallet.
Check balances from the MPC wallet list, then enter the recipient address and amount in the transfer request dialog.

<b>[Column Description]</b>
Wallet Address (MPC) :    MPC wallet address
Signers/Owners :          threshold / partySize (approvers / total owners)
SKP (Pending) :           SKP balance (including deposit)
matic :                   MATIC balance
Transfer :                Transfer request button

<b>[Transfer Request Dialog]</b>
Wallet Address (MPC) :    Sender MPC wallet address (read-only)
Recipient Address :       Select from registered MPC users
Amount :                  SKP amount to transfer`,
    registerAddress: `<b>[Page Description]</b>
A page for registering and managing MPC user addresses.
CRUD operations for user addresses that can be designated as owners when creating MPC wallets.

<b>[Column Description]</b>
Username :      MPC user name
Wallet Address : User wallet address

<b>[Features]</b>
Add (+) :       Register by entering username and wallet address
Delete (-) :    Delete selected user`,
    transferHistory: `<b>[Page Description]</b>
A page for viewing MPC wallet transfer history.
SKP transfer or re-transfer buttons are displayed depending on the approval status.

<b>[Column Description]</b>
Wallet Address (MPC) :    Sender MPC wallet address
Recipient Address :       Receiver address
Amount :                  Transfer amount
Approval Status :         Transaction progress status
Transfer :                SKP transfer/re-transfer button

<b>[Approval Status Codes]</b>
0 : Approval requested
1 : Approval complete (SKP transfer available)
2 : MPC requested
3 : MPC complete / Transfer requested (transaction hash available)
4 : Transfer confirmed
5 : Transfer error
6 : Signature error (SKP re-transfer available)`,
    waitingApproval: `<b>[Page Description]</b>
A page for viewing the MPC wallet transfer approval waiting list.
You can sign (approve) transactions that are awaiting approval.

<b>[Column Description]</b>
Wallet Address (MPC) :    Sender MPC wallet address
Recipient Address :       Receiver address
Amount :                  Transfer amount
Signatures :              Current signatures / required signatures (signer list available)
Approve :                 Approve button`,
  },
  platform: {
    gameNotice: `<b>[Page Description]</b>
A page for managing game announcements.
Create content using SmartEditor, with add, edit, and delete capabilities.
Published on the notice.skyplay.io site.

<b>[Column Description]</b>
Seq :           Sequence number
Gamename :      Game name (clashrow, coingrid)
Category :      Category (Public, Update, Maintenance, Event)
Subject :       Title
Language :      Language (ko/en)
State :         Status (0: New, 1: Old)
Modified Date : Modified date
Created Date :  Created date
link :          View content
edit :          Edit button
delete :        Delete button`,
    pressRelease: `<b>[Page Description]</b>
A page for managing press releases.
Create content using SmartEditor, with add, edit, and delete capabilities.
Published on the skyplayinc.com site.

<b>[Column Description]</b>
Seq :           Sequence number
Subject :       Title
URL :           External link URL
Language :      Language (ko/en)
Created Date :  Created date
link :          View content
edit :          Edit button
delete :        Delete button`,
    tusUploadList: `<b>[Page Description]</b>
A page for viewing the TUS protocol file upload list.
Upload files via drag and drop, with the list auto-refreshing every 3 seconds.
Provides CSV download.

<b>[Column Description]</b>
Seq :           Sequence number
Image :         Image preview (for image files)
MIME Type :     File type (image/png, etc.)
ID :            TUS file ID
Name :          File name
Size :          File size
Created Date :  Upload date
link :          File link (new tab)`,
  },
  portal: {
    board: `<b>[Page Description]</b>
Portal board management page.
View, add, edit, and delete posts, with content editing using SmartEditor.

<b>[Column Description]</b>
Rowid :         Post unique number
Type :          Board type (arena, notice, news, partner, event, info)
Title :         Post title
Language :      Language code (eng, kor, vnm, chn)
Registed Date : Registration date

<b>[Features]</b>
* Add post : Create HTML content with SmartEditor
* Edit post : Load and modify existing content
* Delete post : Delete after confirmation
* View content : Preview on press.metaplanet-nft.com`,
    mintit: `<b>[Page Description]</b>
A page for viewing and confirming Mintit application list.
Provides CSV download and wallet address search.

<b>[Column Description]</b>
seq :             Sequence number
name :            Applicant name
phone :           Phone number
wallet :          Wallet address (copy, explorer link, filter features)
transactionHash : Transaction hash
dateUpdated :     Modified date
dateCreated :     Registration date
confirm :         Confirmation status (checkbox, disabled if transactionHash exists)`,
  },
  portalLog: {
    ltbDeposit: `<b>[Page Description]</b>
This page displays portal deposit logs.
The total count (Total) and total METAQ amount are shown at the top.
Address copy, blockchain Explorer link, and filter features are provided.

<b>[Column Description]</b>
seq :       Sequence number
from :      Sender address
to :        Recipient address
txnhash :   Transaction hash
value :     Deposit amount
redDate :   Registration date`,
    ltbMetaq: `<b>[Page Description]</b>
This page displays portal METAQ balance change logs.
You can check the increase/decrease history and reasons for METAQ changes.

<b>[Column Description]</b>
seq :       Sequence number
wallet :    Wallet address
bef :       Balance before change
val :       Change amount
aft :       Balance after change
reason :    Reason for change
regDate :   Registration date`,
    ltbNftStaking: `<b>[Page Description]</b>
This page displays portal NFT staking logs.
You can check the staking start/end/claim dates for each NFT token.

<b>[Column Description]</b>
seq :           Sequence number
tokenId :       NFT token ID
beginDate :     Staking start date
endDate :       Staking end date
receivDate :    Reward claim date`,
    ltbSwap: `<b>[Page Description]</b>
This page displays portal swap logs.
You can check AQUA to METAQ swap history, with total count and total AQUA amount displayed.
The METAQ amount is automatically calculated as ratio * value.

<b>[Column Description]</b>
seq :       Sequence number
wallet :    Wallet address
contentNo : Content number
ratio :     Exchange ratio
AQUA :      AQUA amount (value)
METAQ :     METAQ amount (ratio x value, calculated)
regDate :   Registration date`,
    ltbTokens: `<b>[Page Description]</b>
This page displays portal token (AQUA) change logs.
You can check the increase/decrease history and reasons for AQUA token changes, with CSV download support.

<b>[Column Description]</b>
seq :           Sequence number
wallet :        Wallet address
contentNo :     Content number
type :          Change type
no :            Number
bef :           Balance before change
val :           Change amount
aft :           Balance after change
reason :        Reason for change
regDate :       Registration date`,
    ltbTransferMetaq: `<b>[Page Description]</b>
This page displays portal METAQ transfer logs.
You can check METAQ transfer history between users.
Address copy, blockchain Explorer link, and filter features are provided.

<b>[Column Description]</b>
seq :       Sequence number
from :      Sender address
to :        Recipient address
val :       Transfer amount
regDate :   Registration date`,
    ltbTransferNft: `<b>[Page Description]</b>
This page displays portal NFT transfer logs.
You can check NFT token ownership transfer history.
Address copy, blockchain Explorer link, and filter features are provided.

<b>[Column Description]</b>
seq :       Sequence number
from :      Sender address
to :        Recipient address
tokenId :   NFT token ID
regDate :   Registration date`,
    ltbWithdraw: `<b>[Page Description]</b>
This page displays portal withdrawal logs.
The total count (Total) and total METAQ withdrawal amount are shown at the top.
You can verify transactions on the blockchain Explorer using the transaction hash.

<b>[Column Description]</b>
seq :           Sequence number
wallet :        Wallet address
value :         Withdrawal amount
regDate :       Request date
txnhash :       Transaction hash
confirmDate :   Confirmation date`,
  },
  portalToken: {
    balanceHistoryProbit: `<b>[Page Description]</b>
This is the Probit exchange Balance History page.
It tracks USDT and METAQ balance changes for LP1/LP2 accounts over time.
The difference (Delta) between the current and past balances is calculated and displayed at the top.
Auto-refreshes every 1 second.

<b>[Column Description]</b>
time :           Recorded time (ISO format)
lp1 usdt :       LP1 account USDT balance
lp2 usdt :       LP2 account USDT balance
usdt :           USDT total (LP1 + LP2)
lp1 metaq :      LP1 account METAQ balance
lp2 metaq :      LP2 account METAQ balance
metaq :          METAQ total (LP1 + LP2)
sum(usdt) :      METAQ x current price + USDT (total asset conversion)
Trade Avg Price : USDT change / METAQ change (top Delta table)

<b>[Reference]</b>
* Top table: Displays current real-time balances and period-based changes (Delta)
* Bottom table: Historical balance records (server-side pagination)
* CSV download available`,
    coinsale: `<b>[Page Description]</b>
This is the Coin Sale participant registration, editing, deletion, and list viewing page.
It displays the total sale amount (Sum) and supports CSV download.

<b>[Column Description]</b>
seq :         Sequence number
nickname :    Participant nickname
description : Description
deposit :     Deposit amount
depositDate : Deposit date
salePrice :   Sale price
metaq :       Allocated METAQ quantity
completed :   Completion status
lockup :      Lockup status

<b>[Notes]</b>
* Wallet addresses must be valid Ethereum addresses to register.
* The Sum display is the totalAmount value calculated by the server.`,
    gasAnalysis: `<b>[Page Description]</b>
This is the Gas Analysis page.
It analyzes gas consumption by network and transaction type, and visualizes the data with charts.
Supports CSV, Excel, and PDF export.

<b>[Filters]</b>
Network :         Network selection (includes All Networks)
From / To :       Date range setting
Gas Price (Gwei) : Gas price setting (default: 20)

<b>[Summary Cards]</b>
Total Transactions : Total number of transactions
Est. Total Gas :     Estimated total gas consumption
Est. Total Cost :    Estimated total cost (ETH)
Avg Gas / TX :       Average gas per transaction

<b>[Charts]</b>
Daily Gas Cost Trend :  Daily TX count (bar) + cost trend (line)
TX Type Distribution :  Transaction type ratio (donut chart)

<b>[Tables]</b>
Network Breakdown :   TX count, gas, and cost by network
Gas by Operation Type : Count, gas per TX, total gas, and ratio by type
Recent Transactions :  Recent transaction list (Hash, Type, From, To, Value, Est. Gas, Network, Time)`,
    lbank: `<b>[Page Description]</b>
This is the LBank exchange real-time trading management page.
It provides orderbook (ask/bid), bot controls, manual orders, and LP-specific volume viewing.
Supports real-time data updates via SSE (Server-Sent Events).

<b>[Features]</b>
LBankPriceHeader : Current price, 24h change rate, exchange rate, spread display
LBankBotControls : Bot activation, floor/ceiling price settings, volume adjustment
LBankOrderBook :   Ask/bid orderbook, LP-specific volume display, manual orders

<b>[Bot Controls]</b>
Bot Start/Stop :  Toggle wash trading bot activation
Price Floor :   Set bot floor price
Price Ceiling : Set bot ceiling price
Volume :        Adjust bot volume ratio (%)

<b>[Orderbook]</b>
LP1/LP2/LP3 : Order quantity for each LP account
Retail Volume : Total quantity - LP total (external volume)
cancel :       Cancel orders at a specific price level
clear :        Place volume-clearing orders`,
    lbankAssetChanges: `<b>[Page Description]</b>
This is the LBank Asset Changes history viewing page.
It displays asset changes from MM bot leaks and manual orders in a unified view.
Supports date range, Side, and Source filters as well as CSV download.

<b>[Column Description]</b>
Source :       Change source (mm_bot: purple, manual: gray)
Side :         Buy/Sell (buy: green, sell: red)
Price :        Trade price
Quantity :     Trade quantity
USDT Change :  USDT change amount (positive: green, negative: red)
METAQ Change : METAQ change amount (positive: green, negative: red)
Time :         Occurrence time

<b>[Stats Summary]</b>
Total Changes :     Total number of changes
Total USDT Change : Total USDT change amount
Total METAQ Change : Total METAQ change amount

<b>[Reference]</b>
* mm_bot: Leak occurrences from lbank_trade_logs (usdtDiff, metaqDiff)
* manual: Filled orders from lbank_trades`,
    lbankLosses: `<b>[Page Description]</b>
This is the LBank exchange Losses history viewing page.
It provides date range and loss type filters, loss statistics, and daily statistics.
Supports CSV download and column settings.

<b>[Column Description]</b>
ID :         Loss record ID
Loss (USDT) : Loss amount (USDT, displayed in red)
Price :      Trade price
Quantity :   Trade quantity
Before :     Total USDT assets before the trade
After :      Total USDT assets after the trade
Type :       Loss type (external_fill, partial_fill)
Detail :     LP-specific balance change details (tooltip)
Created At : Occurrence time

<b>[Stats Summary]</b>
Total Loss Count : Total number of losses
Total Loss (USDT) : Total loss amount

<b>[Daily Loss Statistics]</b>
Date / Loss Count / Total Loss (USDT)`,
    lbankMonitor: `<b>[Page Description]</b>
This is the LBank exchange monitoring dashboard.
It provides a daily trading summary (trade count, leak count, leak quantity, total loss) and detailed information per tab.
Auto-refreshes every 10 seconds.

<b>[Summary Cards]</b>
Today Trades :  Total trade count for today
Today Leaks :   Leak count for today
Leak Quantity : Leak quantity for today (METAQ)
Total Loss :    Total loss for today (USDT)

<b>[Tabs]</b>
Bot Trades :      Bot trade history
Manual Orders :   Manual order history
Balance History : Balance history
Daily Stats :     Daily statistics
Profit Report :   Profit report`,
    lbankOrderHistory: `<b>[Page Description]</b>
This is the LBank exchange Order History viewing page by LP account.
It displays the most recent 300 order records for three accounts (LP1, LP2, LP3) in chronological order.

<b>[Column Description]</b>
time :               Order time
limit_price :        Order price
status :             Order status
side :               Order direction (buy/sell)
quantity :           Order quantity
cancelled_quantity : Cancelled quantity
filled_quantity :    Filled quantity`,
    lbankSchedule: `<b>[Page Description]</b>
This is the LBank bot schedule management page.
It allows you to set bot operating hours by day of the week, apply presets, and visualize the weekly operation status.
Saved to both server and localStorage.

<b>[Features]</b>
Schedule Enable/Disable : Toggle the entire schedule on/off
Daily Start/End Time :    Set operating hours for each day of the week
Quick Presets :
  - Weekdays 9-18 :   Mon-Fri 09:00-18:00
  - Weekdays 24h :    Mon-Fri 00:00-23:59
  - Everyday 24h :    Mon-Sun 00:00-23:59
  - Reset :           Disable all days

<b>[Weekly Overview]</b>
Visualizes operating hours by day of the week as a horizontal bar chart.

<b>[Notes]</b>
* Timezone is based on the browser's local timezone.
* If server save fails, data is saved only to localStorage.`,
    lbankTradeLogs: `<b>[Page Description]</b>
This is the LBank bot Trade Logs viewing page.
It provides detailed information on the wash trading bot's execution history, leak occurrences, and execution times.
Supports date range, Trade Type, and Leak filters as well as daily statistics.

<b>[Column Description]</b>
ID :          Log ID
Type :        Trade type (sell_side: red, buy_side: green)
Price :       Trade price
Quantity :    Trade quantity
Spread :      Ask-bid spread
Status :      Leak status (LEAK: red, OK: green)
Leak Qty :    Leak quantity (displayed only when a leak occurs)
Exec Time :   Execution time (ms)
Balance :     Balance change details (Before/After/Diff, tooltip)
Orders :      Order details (Order1/Order2 success status, tooltip)
Created At :  Occurrence time

<b>[Stats Summary]</b>
Total Trades :      Total trade count
Total Leaks :       Total leak count
Leak Quantity :     Total leak quantity (METAQ)
Avg Execution Time : Average execution time (ms)

<b>[Daily Trade Statistics]</b>
Date / Total Trades / Leak Count / Leak Quantity / Avg Exec Time`,
    lbankTrades: `<b>[Page Description]</b>
This is the LBank exchange Trades history viewing page.
It provides date range and Side (buy/sell) filters, a statistics summary, and daily statistics.
Supports CSV download and column settings.

<b>[Column Description]</b>
ID :         Trade ID
Exchange :   Exchange name
Symbol :     Trading symbol
Side :       Buy/Sell (buy: green, sell: red)
Price :      Filled price
Quantity :   Filled quantity
Amount :     Filled amount (USDT)
Order ID :   Order ID (copyable)
Status :     Order status
Created At : Filled time

<b>[Stats Summary]</b>
Total Trades :   Total trade count
Total Amount :   Total trade amount (USDT)
Total Quantity : Total trade quantity

<b>[Daily Statistics]</b>
Date / Trade Count / Total Amount / Total Quantity`,
    oldToken: `<b>[Page Description]</b>
This is the old token holder list viewing page.
You can check METAQ and AQUA holdings by wallet address for the previous version of the token.
API Endpoint: /metaplanet_token/list_oldtoken

<b>[Column Description]</b>
wallet : Wallet address (copy, filter functions)
metaq :  METAQ holdings
aqua :   AQUA holdings

<b>[Top Summary]</b>
METAQ : Total METAQ holdings sum
AQUA :  Total AQUA holdings sum`,
    presale: `<b>[How to Use]</b>
1. Register presale participants via CSV file upload or the registration dialog.
2. Upon registration, the total METAQ is divided into 10 equal parts and 10 unlock schedules are automatically created at 1-month intervals.
3. Click a row to view the detailed unlock schedule (Allow Date, receipt status).

<b>[Column Description]</b>
Address :       Participant wallet address
Total METAQ :   Total allocated METAQ quantity
Description :   Participant description/name (editable)
Type :          Presale type — presale, advisor, private (editable)
Register Date : Registration date and time
Allow Date :    Unlock period (first to last Allow Date)
Receipt :       Receipt status (received count / total count)
Action :        Delete (only available when unreceived)

<b>[File Upload Format]</b>
CSV file (delimiter: comma), 5 fields required
# address, description, type, metaq, unlockDate
0x18817A4d5C25d3B43eE6EB1cD29304A7133fD877,Hong Gildong,presale,10000,2024-12-25
0x18817A4d5C25d3B43eE6EB1cD29304A7133fD877,Hong Gildong,advisor,10000,2024-12-25

<b>[Registration Dialog]</b>
Address :     Participant wallet address
Description : Participant description
Type :        presale / advisor / private
METAQ :       Total allocation (divided into 10 equal monthly unlocks)
Allow Date :  First unlock start date

<b>[Notes]</b>
* Upon registration, METAQ is divided into 10 equal parts and automatically split into 10 schedules at 1-month intervals.
* Groups that already have received items cannot be deleted.
* Allow Date changes are only available for unreceived groups; when changed, dates are reset at 1-month intervals.
* "Delete All" only deletes unreceived items.`,
    probit: `<b>[Page Description]</b>
This is the Probit exchange real-time trading management page.
It provides orderbook (ask/bid), bot controls, manual orders, and LP-specific volume viewing.
Auto-refreshes every 1 second.

<b>[Top Summary]</b>
Probit :  Probit exchange current price and 24h change rate
LBank :   LBank exchange current price and 24h change rate
Price :   Current price x exchange rate (KRW) converted price
Spread :  Lowest ask price - highest bid price

<b>[Bot Controls]</b>
Bot Start/Stop :  Toggle wash trading bot activation
Base Price :      Set bot base price
Limit Price :     Set bot limit price
Volume :          Bot volume ratio (%) slider

<b>[Orderbook Column]</b>
Price :         Order price
Quantity :      Total quantity
LP1/LP2/LP3 :  Order quantity for each LP account (remaining/original quantity)
Retail Volume : Total quantity - LP total (external volume)
Est. Cost (KRW) : Retail volume x price x exchange rate`,
    probitDeposit: `<b>[Page Description]</b>
This is the Probit exchange Deposit/Withdrawal history viewing page.
It retrieves ERC-20 token transfer history for a specific deposit address (0x898F...) by date range.
Supports address name/type editing and CSV download.

<b>[Column Description]</b>
Block Number :     Block number
Transaction Hash : Transaction hash (copy, explorer link)
Time :             Transfer time
From :             Sender address (name editing, copy, explorer link)
To :               Recipient address (name editing, copy, explorer link)
Value :            Transfer amount

<b>[Reference]</b>
Default, Company, Exchange, Marketing, Sale, Staking,
Team, CM liquidity, Advisor, Unlock, Portal, System

<b>[Reference]</b>
* System wallet addresses are displayed in green.
* The Total area displays the total count and total transfer amount.`,
    probitOrderHistory: `<b>[Page Description]</b>
This is the Probit exchange Order History viewing page by LP account.
It displays the most recent 300 order records for three accounts (LP1, LP2, LP3) in chronological order.

<b>[Column Description]</b>
time :               Order time
limit_price :        Order price
status :             Order status
side :               Order direction (buy/sell)
quantity :           Order quantity
cancelled_quantity : Cancelled quantity
filled_quantity :    Filled quantity`,
    report: `<b>[Page Description]</b>
This is the Report Generator page.
Select various report types, set the date range, and preview or export the data.
Supports CSV, Excel, and PDF export formats.

<b>[Filters]</b>
Report Type : List of report types defined in the REPORT_TYPES constant
From Date :   Start date
To Date :     End date
Period :      Quick period selection (7 days, 30 days, 90 days, Custom)

<b>[Features]</b>
Preview :  Preview selected report data (displayed as a table)
Export :   Export in CSV / Excel / PDF format
           Large datasets are downloaded in page units (progress bar displayed)

<b>[Reference]</b>
* Report type headers, columns, and API endpoints are defined in reportConfig.js.
* Large reports (useLargeExport) use server-side pagination.`,
    token: `<b>[Page Description]</b>
This is the token holder list viewing page.
You can check METAQ and AQUA holdings by wallet address along with the overall totals.

<b>[Column Description]</b>
wallet : Wallet address (copy, explorer link, filter functions)
metaq :  METAQ holdings
aqua :   AQUA holdings

<b>[Top Summary]</b>
METAQ : Total METAQ holdings sum
AQUA :  Total AQUA holdings sum`,
  },
  settings: {
    account: `<b>[Page Description]</b>
A page for registering, editing, and viewing admin accounts (Addresses).
Provides search, CSV download, and blockchain explorer link features.

<b>[Column Description]</b>
Address :      Account wallet address
Description :  Account description
Enabled :      Whether enabled (checkbox)
Edit :         Edit button

<b>[Features]</b>
- Add : Register a new account (stage 3)
- Edit : Edit account information (stage 2)
- Copy : Copy address to clipboard
- Explorer : Look up address on blockchain explorer
- Download CSV : Download full account list as CSV`,
    apiKeys: `<b>[Page Description]</b>
A page for creating, editing, deleting, and viewing API Keys.
Maps ERC20/721/1155 contract addresses per Issuer.
Includes expiration management with color-coded status indicators and renewal alerts.

<b>[Column Description]</b>
ISSUER :          API Key issuer
API Key :         Issued API Key value
ERC20 Address :   ERC20 contract address
ERC721 Address :  ERC721 contract address
ERC1155 Address : ERC1155 contract address
Expires At :      API key expiration date (color-coded: green >30d, yellow 7-30d, red <7d, gray no expiry)
Modified Date :   Date modified
Created Date :    Date created

<b>[Expiry Features]</b>
Set Expiry :      Set or clear an expiration date for an API key
Renew :           Extend the expiry date or regenerate the API key
Filter :          Toggle to show only keys expiring soon
Warning Banner :  Displayed when keys are expiring within 7 days`,
    apiStats: `<b>[Page Description]</b>
A page for viewing overall API call statistics.
Analyzes API call volume, error rate, and response time by period and hour.

<b>[Summary Cards]</b>
Total Calls :    Total number of API calls
Total Errors :   Total number of errors
Error Rate :     Error rate (%)
Avg Response :   Average response time (ms)

<b>[Charts]</b>
Call Volume :    Calls/errors by period (Bar Chart)
Response Time :  Average response time by period (Line Chart)

<b>[Top Methods / Top Errors Table]</b>
Method :  API method name
Calls :   Number of calls
Errors :  Number of errors
Avg Ms :  Average response time`,
    auditLog: `<b>[Page Description]</b>
A page for viewing admin activity logs.
You can check API call records, success/failure status, response time, and more.
Clicking a row allows you to compare before/after setting values via JSON Diff.

<b>[Column Description]</b>
Time :         API call time (UTC)
Address :      Caller wallet address
Method :       Called API method name
Client IP :    Client IP address
Duration(ms) : API response duration (milliseconds)
Success :      Success (OK) / Failure (FAIL)
Error :        Error message (on failure)

<b>[Filters]</b>
- Search Address : Search by address
- Action Type : API category filter (account, permission, role, etc.)
- Date Range : Search by date range
- Export : Download as CSV / Excel / PDF`,
    contractDeploy: `<b>[Page Description]</b>
A page for deploying smart contracts.
Proceeds through a Stepper UI: Select Chain > Token Type > Enter Parameters > Deploy.
After deployment, automatically registers to network_info and saves history.

<b>[Deploy Process]</b>
Step 1 : Select chain (Mainnet/Testnet)
Step 2 : Select token type (ERC20/ERC721/ERC1155) + options
Step 3 : Enter parameters (Name, Symbol, etc.)
Step 4 : Review and deploy (MetaMask signature)

<b>[Deploy Result]</b>
Contract Address :     Deployed contract address
TX Hash :              Transaction hash
Block :                Block number
Registration :         Network auto-registration status`,
    deployHistory: `<b>[Page Description]</b>
A page for viewing smart contract deployment history.
Check deployed contract information, transaction hashes, registration status, and more.

<b>[Column Description]</b>
Created At :        Deployment date and time
Chain :             Chain ID
Token Type :        Token type (ERC20/ERC721/ERC1155)
Options :           Deployment options (Mintable, Burnable, etc.)
Token Name :        Token name
Symbol :            Token symbol
Contract Address :  Contract address
Deployer :          Deployer address
TX :                Transaction hash
Status :            Deployment status (success/fail)
Registration :      Network registration status (success/failed, retryable)`,
    group: `<b>[Page Description]</b>
A page for managing user groups.
Provides group creation, editing, deletion, and role assignment features.
System groups (Admin, Operator, Viewer) cannot be deleted.

<b>[Column Description]</b>
ID :          Group unique ID
Name :        Group name
Description : Group description
Roles :       Number of assigned roles
Members :     Number of group members
Status :      Active/inactive status
Actions :     Edit, assign roles, delete buttons`,
    healthCheck: `<b>[Page Description]</b>
A page for checking system health check status.
Monitors service status in real time with auto-refresh every 30 seconds.
Toggle auto-refresh on/off and use "Check Now" button for instant status check.

<b>[Overall Status Banner]</b>
Displays overall system status with color coding.
Green = All services healthy / Orange = Some warnings / Red = Services down

<b>[Summary Cards]</b>
Uptime :       Server uptime
Memory :       Memory usage (Alloc MB / Sys MB)
Goroutines :   Number of Go routines
Services :     Healthy / Total service count

<b>[Service Status Cards]</b>
MySQL (Metaplanet, Skyplay, Portal) : Individual DB connection status and latency
MongoDB :    MongoDB connection status
Redis :      Redis connection status
API Server : API server self-check response
Disk Space : Disk usage (warning when above 90%)

<b>[Status History]</b>
Shows the last 50 status check records.
Alerts are displayed when status changes (healthy to unhealthy).`,
    ipWhitelist: `<b>[Page Description]</b>
A page for managing IP whitelists.
Restricts admin access to allowed IPs only.

<b>[Column Description]</b>
IP Address :  IP address to allow
Description : IP description (office, VPN, etc.)
Active :      Individual IP enable/disable toggle
Created At :  Registration date and time
Actions :     Delete button

<b>[Notes]</b>
- When the whitelist is enabled, you will be automatically blocked if your current IP is not included
- Self-lock warning display prevents accidental lockout`,
    loginHistory: `<b>[Page Description]</b>
A page for viewing admin login history.
You can check login success/failure records, access IP, and browser information.

<b>[Column Description]</b>
Time :           Login attempt time (UTC)
Address :        Login attempt wallet address
Client IP :      Client IP address
User Agent :     Browser/OS information
Success :        Success (OK) / Failure (FAIL)
Failure Reason : Reason for login failure

<b>[Filters]</b>
- Search Address : Search by address
- Date Range : Search by date range
- Download CSV : Download login history as CSV`,
    network: `<b>[Column Description]</b>
ChainID :             Network identifier — 1(Ethereum), 56(BSC), 137(Polygon), 80001(Polygon Testnet)
Address :             Smart contract address (token deployment address)
TokenType :           Contract type — erc20(token), erc721(NFT), erc1155(multi-token)
Name :                Token/contract name
Symbol :              Token symbol (e.g., METAQ, USDT)
BlockNumber :         Last scanned block number
Initial Block Number: Scan start block number (e.g., contract deployment block)

<b>[Process Status]</b>
<b>Scan</b>
  Tx (Transaction) :  Transaction scan — Collects token transfer records
  Vol (Volume) :      Volume scan — Aggregates trading volume data
  Dep (Deposit) :     Deposit scan — Detects deposit transactions
  SW (Platform Wallet) : Platform wallet scan — Monitors system wallet balances
  HB (Holder Balance) :  Holder balance query — Updates token holder balances
  FT (Flush Token) :  Token collection — Collects scattered tokens to the system wallet

<b>Transfer</b>
  WD (Withdraw) :     Withdrawal processing — Executes user withdrawal requests
  WS (Withdraw Status) : Withdrawal status check — Tracks withdrawal transaction confirmations
  AD (Airdrop) :      Airdrop transfer — Executes bulk token distribution
  AS (Airdrop Status) :  Airdrop status check — Tracks airdrop transaction confirmations
  MT (Minting) :      Minting processing — Issues NFT/tokens
  MS (Minting Status) :  Minting status check — Tracks minting transaction confirmations

<b>State</b>
  Init (Initialized) : Initialization state — Whether network initial setup is complete

● Green: Process running  ● Gray: Process stopped`,
    notificationPreferences: `<b>[Page Description]</b>
A page for managing notification preferences per channel.
Configure in-app, Telegram, and email notification settings individually by notification category.
Settings are saved to the server and also cached in localStorage as fallback.

<b>[Notification Categories]</b>
Trading Alert :      Bot trading activity, order fills, and trade errors
Price Alert :        Token price changes exceeding threshold
System Alert :       System errors, downtime, or maintenance events
Security Alert :     Login attempts, 2FA changes, and suspicious activity
Withdrawal Alert :   Withdrawal requests and completions

<b>[Notification Channels]</b>
In-App :    In-app notification (always available)
Telegram :  Telegram bot notification
Email :     Email notification (SMTP)

<b>[Channel Overview]</b>
Shows the status and active count for each channel at a glance.
Toggle a channel master switch to enable/disable all categories for that channel.

<b>[Quiet Hours]</b>
Configure a time window during which Telegram and email notifications are suppressed.
In-app notifications are not affected by quiet hours.

<b>[Quick Actions]</b>
Enable All :      Turn on all channels for all categories
Disable All :     Turn off all channels for all categories
In-App Only :     Enable only in-app, disable Telegram and email
Telegram Only :   Enable only Telegram, disable in-app and email
Email Only :      Enable only email, disable in-app and Telegram
Reset :           Restore default settings`,
    permissionCode: `<b>[Page Description]</b>
A page for viewing the list of permission codes registered in the system.
You can check the access level and category per API endpoint.

<b>[Column Description]</b>
FullMethod :    Full gRPC method path
Route :         Associated frontend route
Name :          Permission display name
Category :      Category (account, wallet, lbank, etc.)
Access Level :  Access level (public, authenticated, protected)`,
    preferences: `<b>[Page Description]</b>
A page for managing user preferences.
Saves table display count, default date range, sort settings, and more.
Settings are stored in localStorage and maintained per browser.

<b>[Settings]</b>
Default Items Per Page : Default number of table rows (5/10/20/50/100)
Default Date Range :     Default date filter period (3/7/14/30/90 days)
Saved Table Sort :       List of saved sort settings per view
Reset All Preferences :  Reset all settings`,
    role: `<b>[Page Description]</b>
A page for managing roles.
Provides role creation, editing, deletion, and permission assignment features.
Viewer/Operator permissions can be set in bulk or individually per menu group.
System roles (SUPER_ADMIN, ADMIN, OPERATOR, VIEWER) cannot be deleted.

<b>[Column Description]</b>
ID :          Role unique ID
Name :        Role name
Description : Role description
Level :       Permission level (higher means greater privileges)
Groups :      Number of groups this role is assigned to
Permissions : Number of assigned permissions
Status :      Active/inactive status
Actions :     Edit, manage permissions, delete buttons`,
    sessionManagement: `<b>[Page Description]</b>
A page for managing active sessions.
View all currently logged-in sessions and revoke sessions from other devices.

<b>[Session Information]</b>
Browser :       Browser type (Chrome, Firefox, Edge, etc.)
IP Address :    Access IP address
Login Time :    Login time
Last Activity : Last activity time
Expires At :    Session expiration time
User Agent :    Browser/OS detailed information

<b>[Features]</b>
- Current indicator : Currently active session (green border)
- Revoke : Revoke an individual session
- Revoke All Others : Revoke all sessions except the current one`,
    systemWallet: `<b>[Column Description]</b>
Address :          System hot wallet address (auto-generated blockchain account)
Description :      Wallet purpose description (editable)
Contract Address : Associated token contract address
Token Type :       Contract type (erc20, erc721, erc1155)
Balance :          Native token balance (for gas fees, e.g., MATIC, BNB)
Quantity :         Token holdings for the associated contract

<b>[Actions]</b>
Create Wallet :    Generate a new hot wallet account (enter Description then Generate)
Enabled :          Enable/disable wallet — When disabled, excluded from withdrawal/airdrop sending wallets
Description Edit : Edit wallet description (hover over Description column → pencil icon)
Sum :              Total token holdings of all currently displayed wallets`,
    thresholdSetting: `<b>[Page Description]</b>
A page for configuring system thresholds.
Set withdrawal limits, price volatility alerts, and balance maintenance criteria.

<b>[Settings]</b>
Withdrawal Limit :
  - Single Limit : Per-transaction withdrawal limit
  - Daily Limit :  Daily withdrawal limit

Price Volatility Alert :
  - Price Change % :      Price change alert percentage (default 5%)
  - Monitor Interval :    Monitoring interval (minutes)

Balance Maintenance :
  - Min Balance :     Minimum balance threshold
  - Warning Balance : Balance warning threshold`,
    twoFASetting: `<b>[Page Description]</b>
A page for configuring two-factor authentication (2FA/TOTP).
Enhances login security by linking with a TOTP app such as Google Authenticator.

<b>[Procedure]</b>
1. Setup : Scan QR code or manually enter the secret key
2. Verify : Enter the 6-digit verification code to activate
3. Backup : Save backup codes (for recovery if lost)
4. Disable : Can be deactivated by entering a verification code`,
    webauthn: `<b>[Page Description]</b>
A page for managing WebAuthn/FIDO2 hardware security keys.
Register keys like YubiKey for phishing-resistant, passwordless authentication.

<b>[Features]</b>
Register Key :       Register a new hardware security key (cross-platform authenticator)
Key Name :           Assign a friendly name after registration for easy identification
Registered Keys :    View all registered security keys with registration date
Delete Key :         Remove a registered key (with confirmation dialog)
Browser Check :      Automatic browser compatibility detection

<b>[How It Works]</b>
1. Click "Register Security Key" to start the WebAuthn registration flow
2. Insert and touch your hardware security key when prompted by the browser
3. Optionally name the key (e.g. "Office YubiKey", "Backup Key")
4. The key is stored and can be used for authentication during login

<b>[Login Integration]</b>
After entering password/2FA, a "Use Security Key" option is available.
Insert and touch your key to authenticate without entering a TOTP code.

<b>[Notes]</b>
* Requires a modern browser with WebAuthn support (Chrome, Firefox, Safari, Edge)
* Uses cross-platform authenticators (USB/NFC security keys)
* Challenge-response based: private key never leaves the hardware device
* Multiple keys can be registered for backup purposes`,
    withdrawStats: `<b>[Page Description]</b>
Withdrawal Statistics Dashboard for analyzing withdrawal data.
Shows withdrawal counts, amounts, processing times, and rejection rates with period comparison.

<b>[Summary Cards]</b>
Total Withdrawals :   Total number of withdrawal requests in the period
Total Amount :        Total withdrawal amount
Avg Process Time :    Average time from request to completion
Rejection Rate :      Percentage of rejected withdrawals
Each card shows comparison with the previous period of equal length.

<b>[Charts]</b>
Status Breakdown :       Distribution of withdrawals by status (Doughnut Chart)
Daily Volume :           Daily count (bar) and amount (line) with dual axes
Processing Time Trend :  Average processing time over time (Line Chart)
Rejection Rate Trend :   Rejection rate over time (Line Chart)

<b>[Status Detail Table]</b>
Status :     Withdrawal status (Pending, Completed, Failed, Rejected, Blacklisted)
Count :      Number of withdrawals per status
Amount :     Total amount per status
Percentage : Proportion of each status`,
    anomalyDetection: `<b>[Page Description]</b>
Transaction Anomaly Detection automatically monitors transactions for abnormal patterns.
Configure detection rules, view triggered alerts, and acknowledge reviewed anomalies.
Summary cards provide at-a-glance status of active alerts and severity breakdown.

<b>[Detection Rules]</b>
MASS_WITHDRAWAL :    More than N withdrawals in M minutes from the same address
REPEATED_FAILURE :   More than N consecutive failed transactions
UNUSUAL_AMOUNT :     Transaction amount exceeds N standard deviations from average
RAPID_TRANSFERS :    More than N transfers in M minutes
NEW_ADDRESS_LARGE :  Large amount to a never-before-seen address

<b>[Alert Severity Levels]</b>
Critical (Red) :   Immediate attention required
Warning (Yellow) : Potential issue detected
Info (Blue) :      Informational notice

<b>[Summary Cards]</b>
Active Alerts :       Number of unacknowledged alerts
Acknowledged Today :  Number of alerts acknowledged today
Most Common Type :    Most frequently triggered rule type
Severity Breakdown :  Count of Critical / Warning / Info alerts

<b>[Features]</b>
- Enable/disable individual detection rules
- Configure rule parameters (thresholds, time windows)
- Filter alerts by rule type, severity, and status
- Acknowledge alerts to mark them as reviewed
- Auto-refresh every 30 seconds`,
    walletMonitor: `<b>[Page Description]</b>
A page for monitoring system wallet balances and configuring low balance alerts.
Displays current balances with 24h change tracking and color-coded alert status.

<b>[Wallet Cards]</b>
Address :       Wallet address (shortened)
Balance :       Current token balance
24h Change :    Balance change percentage over last 24 hours
USD Value :     Estimated USD value
Threshold :     Configured minimum balance threshold
Status :        Healthy (green) / Warning (yellow, < 2x threshold) / Critical (red, below threshold)

<b>[Balance History Chart]</b>
- Line chart showing balance over time for the selected wallet
- Period filters: 7D, 30D, 90D
- Threshold lines: Critical (red dashed) and Warning (orange dashed)

<b>[Alert Configuration Table]</b>
Wallet Address : Monitored wallet address
Network :        Blockchain network
Token :          Token symbol
Min Balance :    Minimum balance threshold
Channels :       Notification channels (inApp, telegram, email)
Enabled :        Alert active status
Actions :        Edit / Delete

<b>[Features]</b>
- Auto-refresh every 60 seconds
- Click a wallet card to view balance history chart
- Add/edit/delete alert configurations per wallet
- Multi-channel notification support (In-App, Telegram, Email)`,
    priceAlert: `<b>[Page Description]</b>
Configure automatic token price alerts with multiple notification channels.
Set conditions for price above/below a threshold or percentage change.

<b>[Alert Conditions]</b>
Price Above :     Trigger when price rises above the specified USD value
Price Below :     Trigger when price drops below the specified USD value
Change % :        Trigger when price changes by more than the specified percentage

<b>[Notification Channels]</b>
In-App :          Alert appears in the notification center
Telegram :        Send alert via Telegram bot
Email :           Send alert via email

<b>[Quick Presets]</b>
+5% / +10% / -5% / -10% : Quick-create a percentage change alert

<b>[Features]</b>
- Enable/disable individual alerts with toggle switch
- View trigger count and last triggered time
- Alert history with filtering by specific alert
- Multiple notification channels per alert`,
    backupMonitor: `<b>[Page Description]</b>
A page for monitoring MySQL and MongoDB backup status.
Displays backup health status, history, and allows manual backup triggering and configuration.

<b>[Status Cards]</b>
MySQL Backup :   MySQL backup status with last backup time, size, age, and file count
MongoDB Backup : MongoDB backup status with last backup time, size, age, and file count
Status Colors :  Green (OK, less than 24h) / Yellow (Warning, 24-48h) / Red (Critical, more than 48h)

<b>[Backup History Table]</b>
Type :        Database type (MySQL / MongoDB)
File Name :   Backup file or directory name
Size :        Total backup size
Backup Time : Timestamp of the backup
Age :         Hours since backup was created
Status :      OK / Warning / Critical based on age

<b>[Backup Configuration]</b>
Schedule (Cron) :    Cron expression for automatic backup scheduling (e.g., 0 2 * * *)
Retention (Days) :   Number of days to keep backup files before cleanup
Backup Path :        Filesystem path where backups are stored
Enabled :            Enable/disable automatic scheduled backups

<b>[Features]</b>
- Manual backup trigger with confirmation dialog
- Auto-refresh status every 60 seconds
- Paginated backup history with type filter
- Per-database backup configuration`,
  },
}
